import type { FaireProductEntity } from "../../entity_types/product";

export const p_6e5f35prgg: FaireProductEntity = {
  token: "p_6e5f35prgg",
  type: "product",
  name: "Trophy Husband Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/171b36e805a32f7d3af3abe2531538fa818ed013307115eae32e140488a46658.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9824a1666db0c865165001574f22664cdc27e18bda913deb540da7ed3483123c.jpeg",
    "https://cdn.faire.com/fastly/e3e93c700e65fee1f360c30b0dfa3522d1ab5135d27c8bcff410aa7261252ef7.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ccf0069e4ce282570922ef3844acf2ee88bbf933b44c2a9e3836ff32daaee41a.jpeg",
    "https://cdn.faire.com/fastly/fed606c4e6d193446e9ee43f13fcb6b6abc5216b5fd3589d96b3cc2ff3d880f9.jpeg",
    "https://cdn.faire.com/fastly/246e98afd1590f8d4abff7d2f54ebf689c431e2389ac8cede00155cbabd76023.jpeg"
  ],
  priceDollars: 6.75,
  description: "For all you fellas out there that know what you are - a piece of arm candy for your wife to show off. Now give us a spin.\n\nPerfect Father’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:55.495Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
